<!-- <nav class="nav nav-pills nav-justified nav-title">
    <a class="nav-link " routerLink="/evaluation/observeSOP/reportSop" routerLinkActive='active'>{{ 'EVALUATION.SUMMARISED_REPORT_OK' | translate }}</a>
    <a class="nav-link" routerLink="/evaluation/observeSOP/statistical" routerLinkActive='active'>{{ 'EVALUATION.STATISTICAL_EVALUATION' | translate }}</a>
</nav> -->
<router-outlet></router-outlet>
